export default {
  "common": {
    "ok": "OK",
    "language": "Language",
    "languageLoadFailed": "Failed to load language resources. Switched to Simplified Chinese.",
    "search": "Search",
    "reset": "Reset",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "close": "Close",
    "loading": "Loading…",
    "to": "to",
    "all": "All",
    "selectAll": "Select all",
    "exportExcel": "Export Excel",
    "exportReport": "Export report",
    "exportDetail": "Export details",
    "dateStart": "Start date",
    "dateEnd": "End date",
    "today": "Today",
    "recentPrefix": "Recent: ",
    "oneMonth": "1 month",
    "finance": "Finance",
    "type": "Type",
    "time": "Time",
    "remark": "Remark",
    "operator": "Operator",
    "account": "Account",
    "status": "Status",
    "amount": "Amount",
    "orderNo": "Order No.",
    "selectDate": "Please select a date",
    "exportProcessing": "File is processing. Check Download Center for results.",
    "paySuccess": "Paid",
    "payFailed": "Payment failed",
    "income": "Income",
    "expense": "Expense",
    "incomeExpenseType": "Income/Expense",
    "rechargeMethod": "Recharge method",
    "serialNo": "Serial No.",
    "transactionNo": "Transaction No.",
    "rechargeAccount": "Recharge account",
    "rechargeAmount": "Recharge amount",
    "passportNo": "Passport No.",
    "name": "Name",
    "category": "Category",
    "visaRegion": "Visa region",
    "visaType": "Visa type",
    "couponChange": "Coupon change",
    "couponBalance": "Coupon balance",
    "countryVisaType": "Country / Visa type",
    "namePassport": "Name / Passport",
    "couponUnit": "coupons",
    "yuan": "CNY",
    "requestLoading": "Loading data…",
    "dateRangeTo": "to",
    "operatorStaff": "Operator",
    "amountWithYuan": "Amount (CNY)",
    "balanceWithYuan": "Balance (CNY)",
    "inputPlaceholder": "Please enter",
    "confirmModify": "Confirm change",
    "enterNumber": "Please enter a number",
    "enterPositiveNumber": "Please enter a number greater than 0"
  },
  "nav": {
    "visaTools": "VisaTools",
    "insurance": "Insure",
    "visaService": "Visa",
    "fliggyOrders": "Fliggy",
    "wangdan": "Orders",
    "shanfu": "sdPay",
    "overseasTravel": "Overseas Travel",
    "downloadCenter": "Download",
    "accountMgmt": "Account",
    "finance": "Finance",
    "freeLogin": "Guest",
    "couponAccount": "Coupon Account (Visa Tools)",
    "shanfuAccount": "Flash Pay (Visa Fee)",
    "insuranceAccount": "Insurance Account",
    "recharge": "Top Up",
    "accountDetail": "Account Details",
    "couponUnit": "coupons",
    "yuan": "CNY",
    "bindMobile": "Bind Mobile",
    "editPassword": "Change Password",
    "logout": "Log Out",
    "acquiring": "Acquiring"
  },
  "platform": {
    "couponAccountLabel": "Coupon Account (Visa Tools Service Fee)",
    "mallAccountLabel": "Cash Account (Russia Visa Fee)",
    "wangdanIntroAlt": "Wangdan introduction"
  },
  "financial": {
    "sidebar": {
      "rechargeCenter": "Recharge Center",
      "couponDetail": "Coupon Details",
      "mallAccount": "Cash Account",
      "usa": "USA",
      "malay": "Malaysia",
      "visaFeeAccount": "Visa Fee Account"
    },
    "breadcrumb": {
      "couponDetail": "Coupon Details",
      "cashAccount": "Cash Account",
      "usaAccount": "US Visa Fee Account",
      "malayAccount": "Malaysia Visa Fee Account"
    },
    "tabs": {
      "recharge": "Top Up",
      "expenditure": "Spending"
    },
    "payment": {
      "payMethod": "Payment method",
      "scanPay": "Scan to pay",
      "bankTransfer": "Bank transfer",
      "scanHint": "Pay with Alipay or WeChat",
      "accountNo": "Account No.",
      "accountName": "Account name",
      "bankName": "Bank",
      "bankAccountName": "Zhejiang Baoniu Information Technology Co., Ltd.",
      "bankBranch": "China Merchants Bank Hangzhou Chengxi Branch",
      "rechargeSuccess": "Top-up successful",
      "continueRecharge": "Top up again",
      "viewRecords": "View records",
      "payable": "Amount due",
      "inputAmount": "Enter amount",
      "back": "Back",
      "rechargeNow": "Top up now",
      "alipayPay": "Alipay",
      "scanToPay": "Scan to pay",
      "cancelPay": "Cancel payment",
      "confirmPaid": "Payment confirmed",
      "noScanInfo": "No QR code available."
    },
    "recharge": {
      "selectAmountTitle": "Select coupon amount",
      "selectAmountDesc": "Coupons pay visa tool service fees. Non-refundable after top-up.",
      "couponBalance": "Coupon balance",
      "rateHint": "1 coupon = 1 CNY",
      "cashInputTitle": "Enter cash top-up amount",
      "cashInputDesc": "Cash pays embassy visa fees",
      "cashBalance": "Cash account balance",
      "cashAccountDesc": "Cash account is used for embassy visa fees",
      "mallBalanceDesc": "(Cash account is used for embassy visa fees)",
      "couponBalanceLabel": "Coupon balance",
      "couponRechargeTitle": "Coupon top-up",
      "offlineNoticePrimary": "Online top-up is unavailable. Please contact your business manager to recharge.",
      "offlineNoticeSecondary": "If you cannot reach your business manager, contact customer service (9:00–21:00).",
      "servicePhone": "Customer service phone",
      "serviceWechat": "Customer service WeChat",
      "servicePhoneNo": "0571-87670963"
    },
    "coupon": {
      "summaryConsume": "Total spent: {n} coupons",
      "summaryRecharge": "Total topped up: {n} coupons",
      "orderType": "Order type",
      "summarySeparator": " | "
    },
    "mall": {
      "balanceTitle": "Cash account balance",
      "rechargeTitle": "Cash account top-up",
      "accountBalance": "Account balance",
      "rechargeAmountLabel": "Top-up amount",
      "rechargeAmountRequired": "Please enter top-up amount",
      "rechargeAmountPlaceholder": "Enter the amount to top up",
      "scanPaySupport": "Alipay and WeChat supported",
      "notRecharged": "Payment not received. Please scan again.",
      "iHaveRecharged": "I have paid",
      "rechargeFailed": "Top-up failed. Please try again later.",
      "rechargeCancelled": "Top-up cancelled. Please retry.",
      "qrcodeAlt": "Payment QR code",
      "amountMustNumber": "Amount must be a number",
      "amountMustPositive": "Amount must be greater than 0"
    },
    "usa": {
      "cgiNo": "CGI No.",
      "receiptNo": "Receipt No.",
      "spendAmount": "Amount spent",
      "customerName": "Customer name",
      "payTime": "Payment time"
    },
    "malay": {},
    "dialog": {
      "selectRechargeItem": "Select top-up option",
      "couponFor": "Coupons can be used for:",
      "applyVisa": "Visa applications",
      "useVisaTool": "Visa tools",
      "usaExpedited": "US expedited appointment",
      "accountLabel": "Account: ",
      "lybAccount": "7497 7132 5301",
      "lybAccountName": "Shenzhen Lvyunbao Technology Co., Ltd.",
      "lybBankBranch": "Bank: Bank of China Shenzhen Futian Sub-branch",
      "defaultAccount": "5719 1190 2610 901",
      "notice1": "1. Coupons pay value-added visa tool service fees on the platform.",
      "notice2": "2. Successful top-up means platform services have started.",
      "notice3": "3. Coupon balance is virtual currency and non-refundable. Please confirm before topping up.",
      "listApplyVisa": "1. Visa applications",
      "listUseVisaTool": "2. Use visa tools",
      "listUsaExpedited": "3. US expedited appointment",
      "ticketRecharge": "Coupon top-up",
      "rateResolve": "1 CNY = 1 coupon",
      "rechargeChoice": "Amount: ",
      "payableAmount": "Amount due: ",
      "rechargeMethod": "Payment method: ",
      "payNow": "Pay now",
      "alipayOnly": "Alipay only for now",
      "visaFeeOnlineRecharge": "Online visa fee top-up",
      "step1": "Step 1: ",
      "step2": "Step 2: ",
      "step3": "Step 3: ",
      "alipayScan": "Scan with Alipay",
      "fillRemark": "Add remark",
      "autoCredit": "Auto credit",
      "alipayScanAlt": "Alipay scan",
      "fillRemarkAlt": "Add remark",
      "autoCreditAlt": "Auto credit",
      "scanPayHint": "Tap \"Scan to pay\" below, then pay with Alipay",
      "remarkHintLyb": "Enter \"旅-recharge account\" in the remark field only. Do not add extra text.",
      "remarkHintDefault": "Enter the account to top up in the remark field only. Do not add extra text.",
      "remark": "Remark",
      "autoCreditHint": "After payment, tap \"Payment confirmed\". Funds arrive within 2 hours.",
      "accountRechargeTitle": "Account top-up",
      "accountBalanceLabel": "Balance: ",
      "rechargeAmountColon": "Amount: "
    }
  },
  "message": {
    "list": {
      "title": "Messages",
      "all": "All",
      "submitFailure": "Submit failed",
      "unpaidMoney": "Unpaid embassy fee",
      "comeVisa": "Visa issued",
      "rejectVisa": "Visa rejected",
      "notification": "Notifications"
    },
    "common": {
      "viewDetail": "View details",
      "noData": "No messages"
    },
    "submitFailure": {
      "empty": "No submit-failure messages",
      "title": "Submit failure notification"
    },
    "unpaidMoney": {
      "empty": "No unpaid embassy fee messages",
      "title": "Unpaid embassy fee notification"
    },
    "comeVisa": {
      "empty": "No visa issued messages",
      "title": "Visa issued notification",
      "viewButton": "Visa issued notification"
    },
    "rejectVisa": {
      "empty": "No visa rejected messages",
      "title": "Visa rejected notification"
    }
  },
  "account": {
    "password": {
      "title": "Change password",
      "oldPassword": "Current password",
      "newPassword": "New password",
      "confirmPassword": "Confirm password",
      "oldRequired": "Please enter current password",
      "newRequired": "Please enter new password",
      "confirmRequired": "Please confirm password",
      "mismatch": "Passwords do not match",
      "success": "Password updated",
      "legacyOld": "Current password",
      "legacyNew": "New password",
      "oldEmpty": "Current password is required",
      "newEmpty": "New password is required",
      "patternOld": "Enter 6–16 characters (letters and/or digits)",
      "patternNew": "Enter 8–16 characters with letters and digits",
      "samePassword": "New password must differ from current password",
      "modifySuccess": "Password updated"
    }
  }
};
